import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateService, Transition } from '@uirouter/core';
import { Subscription } from 'rxjs';

import { Util } from 'services/util';
import { Analytics, Cloudinary, SessionStorage, XmStore, XmStoreUtil } from 'core/services';
import { AddonRouteType, USAGE_SUMMARY_STATE } from 'my-account/constants';

import { CmsInternationalCalling } from 'store/cms/models';
import { Addon, AddonCollections } from 'store/addons';
import { InternationalRate } from 'store/international-rates/models/international-rates';

@Component({
    selector: 'xm-international-calling',
    templateUrl: './international-calling.html',
    styleUrls: ['./international-calling.scss'],
    standalone: false
})

export class XmInternationalCalling implements OnInit, OnDestroy {

    public pageData: CmsInternationalCalling;
    public internationalIcon: MediaImageOptions;
    public addonData: Addon;
    public mexCanData: CmsSearchData;
    public notFoundIcon: MediaImageOptions;
    public rateDetails: InternationalRate;
    public hasSelectedCountry: boolean = false;
    public countryFound: boolean = false;

    private xmStore: XmStore;
    private state: StateService;
    private transition: Transition;
    private sessionStorage: SessionStorage;
    private subscriptions: Subscription[] = [];
    private analytics: Analytics;

    constructor(analytics: Analytics, xmStore: XmStore, state: StateService, transition: Transition, sessionStorage: SessionStorage) {
        Object.assign(this, { analytics, xmStore, state, transition, sessionStorage });
    }


    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsInternationalCalling>(CmsInternationalCalling), (result: CmsInternationalCalling) => {
            this.pageData = result;

            this.notFoundIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.notFoundIcon)
            };
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<AddonCollections>(AddonCollections, { filters: { lineId: this.state.params.line_id } }), (addons: AddonCollections) => {
            this.addonData = addons.addons.find((addon: Addon) => (addon.isMexicoCanadaPass));
            this.mexCanData = this.addonData.isActive ? this.pageData.maxCanActiveData : this.pageData.maxCanInActiveData;
            this.mexCanData.description = this.mexCanData.description.replace('[PRICE]', this.addonData.price.toString());
        }));
    }

    public setSelectedCountry(details: InternationalRate): void {
        this.hasSelectedCountry = true;
        this.rateDetails = details;
        this.countryFound = Boolean(this.rateDetails);

        const analyticsParams: object = {
            type: 'authenticated call rates search',
            term: details && details.displayName
        };

        this.analytics.sendCustomEvent('rate-search', analyticsParams);
    }

    public addAddon(): void {
        this.state.go('account.activity.addon.review', { addon_type: AddonRouteType.MEX_CAN_PASS, intent: 'add' });
    }

    public gotItCta(): void {
        if ((this.transition.from().name === 'account.activity.usage' || this.transition.from().name === 'account.billing.usage') && this.transition.params('from')) {
            this.state.go(this.transition.from().name,
                { statement_line_id: this.transition.params('from').statement_line_id, activity: this.transition.params('from').activity, startDate: this.transition.params('from').startDate,
                    endDate: this.transition.params('from').endDate, name: this.transition.params('from').name, lineNumber: this.transition.params('from').lineNumber });
        } else if (this.sessionStorage.get(USAGE_SUMMARY_STATE)) {
            this.state.go('account.billing.landing');
        } else {
            this.state.go('account.activity.details.call-from-us', { line_id: this.state.params.line_id });
        }
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
